const f = (r) => {
  const s = "iress-p";
  return r ? typeof r == "string" ? [`${s}--${r}`] : Object.keys(r).some(
    (e) => e === "x" || e === "y" || e === "b" || e === "l"
  ) ? Object.entries(r).map(([e, t]) => `${s}${e}--${t}`) : Object.entries(r).flatMap(([e, t]) => typeof t == "string" ? `${s}-${e}--${t}` : Object.entries(t).map(
    ([$, i]) => `${s}${$}-${e}--${i}`
  )) : [];
};
export {
  f as getResponsivePaddingClasses
};
